export const meRoutes = {
  profile: '/me',
  changePassword: '/me/doi-mat-khau',
  payroll: '/me/bang-luong',
  journalEntry: '/me/cong-no'
};
